<p-dialog
  [contentStyle]="{ overflow: 'visible', 'max-height': '60vh', 'max-width': '55vw' }"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  (onHide)="closeIndex('validation')"
  >
  <ng-template pTemplate="header">
    <span class="p-dialog-title">
      {{ titleDelete }}
    </span>
  </ng-template>
  <div class="col-12 align">
    <span>{{ tools.getSelectdedCount(selectedDocs.length) }}</span>
  </div>

  @if (selectedDocs.length === 1) {
    <div class="col-12 align">
      <span>{{ selectedDocs[0].doc_name }}</span>
    </div>
  }

  @if (bskMode === true) {
    <div class="col-12">{{'Bsk_Cur' | translate}}  {{ currentSelectedBsk.bskLabel }}</div>
  }@else {
    <div class="col-12">
      <p-checkbox
        name="copyDelete"
        [(ngModel)]="archivDelete"
        binary="true"
        inputId="copyDelete"
      ></p-checkbox>
      <label for="copyDelete" class="ml-2">{{'Copy_Keep' | translate}}</label>
    </div>
  }
  <div class="col-12 md:col-12 align-right">
    <button type="button" pButton class="margin p-button-primary p-button-outlined" (click)="closeIndex('validation')" label="{{'Cancel' | translate}}"></button>
    <button type="button" pButton class="margin p-button-danger" (click)="clickDelDoc()" label="{{'Delete' | translate}}"></button>
  </div>
</p-dialog>

